var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"pre-span",style:({ width: _vm.pre_item.width + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }